export const LEGAL_COMPLIANCE_MESSAGES = {
  DOCUMENTS_UPDATED:
    "Our Terms and Conditions, Privacy Policy, and End User License Agreement have been updated. Please review and accept to continue.",
  ACCEPTANCE_REQUIRED:
    "You must accept our Terms and Conditions, Privacy Policy, and End User License Agreement to continue using the app.",
} as const;
